export function makeSellCarouselImages(deviceType) {
  const filters = deviceType === 'phone' ? "c_lfill,g_north,h_600,w_600" : "c_scale,w_2000";
  return {
    1: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img1.png`,
      alt:
        "Sell your theater tickets, Broadway tickets and comedy tickets on StubHub today."
    },
    2: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img2.png`,
      alt: "Sell your sports tickets on StubHub today."
    },
    3: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img3.png`,
      alt: "Sell your NBA and NCAA tickets on StubHub today."
    },
    4: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img4.png`,
      alt: "Sell your concert and theater tickets on StubHub today."
    },
    5: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img5.png`,
      alt: "Sell your concert tickets on StubHub today."
    },
    6: {
      src: `/l_sell:cta-backgrounds:purple/${filters}/sell/cta-backgrounds/img6.png`,
      alt: "Sell your sports, concerts, and theater tickets on StubHub today."
    }
  };
}
